import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import axios from 'axios';
import {
  startSetContracts,
  startAddContract,
} from '../../../../actions/contracts';
import Layout from '../../../../components/Layout/Layout';
import Card from '../../../../components/Card/Card';
import { FMessage, iFMessage } from '../../../../hoc/IntlComponents';
import ContractsOpeningWords from '../../../../components/Contracts/ContractsOpeningWords';
import ContractsForm from '../../../../components/Contracts/ContractsForm';
import WithAlert from '../../../../hoc/WithAlert';
import AddedContracts from '../../../../components/Contracts/AddedContracts';
import ProfileNav from '../../components/ProfileNav/ProfileNav';
import { Col } from 'reactstrap';
import ProfileCard from '../../components/ProfileCard/ProfileCard';

const types = ['ip', 'ooo'];

class ContractsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 0,
      loading: false,
      errors: {},
      error: false,
    };
  }

  handleTypeChange = type => {
    this.setState(() => ({ type }));
  };

  getContracts = () => {
    const { showAlert, startSetContracts } = this.props;
    this.setState({
      loading: true,
      error: false,
    });
    const reqArray = types.map((value, index) => startSetContracts(index));
    axios
      .all(reqArray)
      .catch(({ response }) => {
        if (response && response.data && response.data.error) {
          const { message: error } = response.data.error;
          showAlert({
            alertType: 'danger',
            message: error.message,
            dismissable: true,
          });
          this.setState({ error: true });
        }
      })
      .finally(() => this.setState({ loading: false }));
  };

  componentDidMount() {
    this.getContracts();
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   const { showAlert, startApproveContract, intl } = this.props;
  //   const prevLength = size(this.props.contracts['ip']) + size(this.props.contracts['ooo']);
  //   const nextLength = size(nextProps.contracts['ip']) + size(nextProps.contracts['ooo']);
  //   if (nextLength - prevLength === 1) {
  //     const prevContractsIds = flatten(
  //       Object.keys(this.props.contracts).map(key => {
  //         return map(this.props.contracts[key], el => `${key}_${el.id}`);
  //       }),
  //     );
  //     const nextContractsIds = flatten(
  //       Object.keys(nextProps.contracts).map(key => {
  //         return map(nextProps.contracts[key], el => `${key}_${el.id}`);
  //       }),
  //     );
  //     let newId = null;
  //     nextContractsIds.forEach(id => {
  //       if (!prevContractsIds.includes(id)) {
  //         newId = id;
  //       }
  //     });
  //     if (newId) {
  //       const [type, itemId] = newId.split('_');
  //       const element = nextProps.contracts[type][itemId];
  //       startApproveContract(type, element).then(() => {
  //         showAlert({
  //           alertType: 'success',
  //           message: iFMessage({ intl, id: 'contracts.alert.approve.success' }),
  //           dismissable: true,
  //         });
  //       });
  //     }
  //   }
  // }

  getContractsCount = () => {
    const { contracts } = this.props;
    let count = 0;
    types.forEach(type => (count += Object.keys(contracts[type]).length));
    return !!count;
  };

  onSubmit = item => {
    const { startAddContract, showAlert, intl } = this.props;
    const { type } = this.state;
    this.setState(() => ({ loading: true }));
    startAddContract(type, item)
      .then(() => {
        showAlert({
          alertType: 'success',
          message: iFMessage({ intl, id: 'contracts.alert.add.success' }),
          dismissable: true,
        });
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.error) {
          const { message: error } = response.data.error;
          showAlert({
            alertType: 'danger',
            message: error.message,
            dismissable: true,
          });
        }
      })
      .finally(() => {
        this.setState(() => ({ loading: false }));
      });
  };

  render() {
    const { contracts, showAlert } = this.props;
    const { loading, type, error } = this.state;

    return (
      <Layout formattedTitle="pages.contracts.title">
        <Col lg="4">
          <Card>
            <Card.Body>
              <ProfileCard />
            </Card.Body>
          </Card>
          <Card>
            <ProfileNav />
          </Card>
        </Col>
        <Col lg="8">
          <Card loading={loading}>
            <Card.Header>
              <FMessage id="pages.contracts.title" />
            </Card.Header>
            <Card.Body>
              <ContractsOpeningWords />
              <ContractsForm
                type={type}
                types={types}
                onSubmit={this.onSubmit}
                contracts={contracts}
                disabled={error}
                handleTypeChange={this.handleTypeChange}
                inModal={false}
                loading={loading}
              />

              {this.getContractsCount() && (
                <AddedContracts
                  contracts={contracts}
                  types={types}
                  typeIndex={type}
                  error={error}
                  showAlert={showAlert}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Layout>
    );
  }
}

const mapStateToProps = ({ contracts }) => ({ contracts });

const mapDispatchToProps = dispatch => ({
  startSetContracts: type => dispatch(startSetContracts(types[type])),
  startAddContract: (type, item) => dispatch(startAddContract(types[type], item)),
  // startApproveContract: (contractType, item) => dispatch(startApproveContract(contractType, item)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithAlert(injectIntl(ContractsPage)));
